import { useSelector } from "react-redux";

// Extra family lists shown only on specific invites. Each key matches every invite whose
// pathname contains it (e.g. "Etasha-Pulkit", "Etasha-Pulkit-1", ...).
const EXTRA_LISTS = {
  "Etasha-Pulkit": [
    {
      title: "Nanihal Paksh",
      names:
        "Mrs. Kanchan - Mr. Onkar Lal Ji Doshi\nMrs. Poonam - Mr. Kamal Ji Doshi\nMrs. Kalpana - Mr. Deepak Ji Doshi\nLate Mrs. Bindu - Mr. Rajesh Ji Haran\nEntire Doshi Parivar",
    },
    {
      title: "Samdhi Paksh",
      names: "Shriman Kanhaiya Lal Ji,\nKalu Lal Ji, Pawan Kumar Ji\nSunil Kumar Ji Bhandari\nEntire Bhandari Parivar Nandeshma Vale",
    },
    {
      title: "Welcome by little ones",
      names: "Gungun Haran, Pranav, Milan, Yuvraj and Manveer Doshi",
    },
  ],
};

const getExtraLists = (pathname = "") => {
  const key = Object.keys(EXTRA_LISTS).find((k) => pathname?.includes(k));
  return key ? EXTRA_LISTS[key] : [];
};

/**
 * The invitee (family) lists every theme shows, in order, as { title, names, order }.
 * `order` is the list's fixed position, so themes can stagger animations the same way
 * whichever lists are filled. Empty lists are left out, and nothing is returned
 * unless at least one of the three main lists is filled.
 */
export const getInviteeLists = (invite = {}) => {
  const { bestComplimentsFrom, warmRegards, invitingWithGreatPleasure,welcomeBy, pathname } = invite || {};
  if (!bestComplimentsFrom && !warmRegards && !invitingWithGreatPleasure && !welcomeBy) return [];

  return [
    { title: "Best Compliments From", names: bestComplimentsFrom },
    { title: "Warm Regards", names: warmRegards },
    { title: "Inviting With Great Pleasure", names: invitingWithGreatPleasure },
    { title: "Welcome By", names: welcomeBy },
    ...getExtraLists(pathname),
  ]
    .map((list, order) => ({ ...list, order }))
    .filter((list) => list.names);
};

/** The invitee lists for the loaded invite (see getInviteeLists). */
export const useInviteeLists = () => getInviteeLists(useSelector((state) => state.inviteDetails.invite));

/**
 * Renders the invitee lists with each theme's own markup: `children` is called with
 * the lists and should return the wrapper. Renders nothing when there are no lists.
 */
const InviteeLists = ({ children }) => {
  const lists = useInviteeLists();
  return lists.length ? children(lists) : null;
};

export default InviteeLists;
